import { Component } from '@angular/core';

@Component({
    selector: 'tasks-onboarding',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss'],
    standalone: false
})
export class TasksOnboardingComponent {
  constructor() {}
} 